export const data = [
  {
    id: 1,
    heading: 'Golden Dunes',
    subHeading: 'Timeless Sandy Charm',
    text: 'Inspired by the warmth of sunlit beaches, this shade adds a touch of elegance and sophistication to any outfit.',
    swatchColor: '#E6D3C4',
    background: '#E5E5E5',
    headingColor: '#000',
    buttonColor: { text: '#000', background: '#D7B172' },
    itemList: {
      bag: {
        color: '#E6D3C4',
      },
      strap: {
        color: '#5E2B17',
      },
      metal: {
        color: '#D7B172',
      },
    },
  },
  {
    id: 2,
    heading: 'Rustic Walnut',
    subHeading: 'Deep Brown with a Warm Hue',
    text: 'Reminiscent of autumn leaves and rich earth tones, this deep brown adds warmth and a classic touch to any ensemble.',
    swatchColor: '#4e4641',
    background: '#79716C',
    headingColor: '#ffffff',
    buttonColor: { text: '#ffffff', background: '#774a37' },
    itemList: {
      bag: {
        color: '#774a37',
      },
      strap: {
        color: '#503830',
      },
      metal: {
        color: '#d4c5b5',
      },
    },
  },
  {
    id: 3,
    heading: 'Deep Sea Voyage',
    subHeading: 'Mystic Blue with Coral Accents',
    text: 'Evoking the vastness of the ocean, this striking blue shade brings a sense of adventure and tranquility to your style.',
    swatchColor: '#4F92B1',
    background: '#C1D6E3',
    headingColor: '#1F333E',
    buttonColor: { text: '#fff', background: '#2f7393' },
    itemList: {
      bag: {
        color: '#2f7393',
      },
      strap: {
        color: '#1d1b1b',
      },
      metal: {
        color: '#F2F2F2',
      },
    },
  },
];
